module.exports = __webpack_public_path__ + "static/media/phone.0e24ed34.svg";